import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { FirebaseContext } from "../../firebase";

const Catalogos = () => {
  const { regionId } = useParams(); // 👈 capturamos la región de la URL
  const { firebase } = useContext(FirebaseContext);
  const [insumos, setInsumos] = useState([]);

  useEffect(() => {
    const unsubscribe = firebase.db
      .collection(`productos_${regionId}`) // 👈 ejemplo: productos_arequipa
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setInsumos(data);
      });

    return () => unsubscribe();
  }, [firebase.db, regionId]);

  return (
    <div className="w-full h-full p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Catálogo {regionId.toUpperCase()}</h1>
        <Link
          to={`/nuevo-insumo/${regionId}`}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          ➕ Añadir Insumo
        </Link>
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="px-4 py-2 text-left text-sm font-semibold">Imagen</th>
              <th className="px-4 py-2 text-left text-sm font-semibold">Nombre</th>
              <th className="px-4 py-2 text-left text-sm font-semibold">Categoría</th>
              <th className="px-4 py-2 text-left text-sm font-semibold">Precio</th>
              <th className="px-4 py-2 text-left text-sm font-semibold">Descripción</th>
              <th className="px-4 py-2 text-center text-sm font-semibold">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {insumos.length > 0 ? (
              insumos.map((insumo) => (
                <tr key={insumo.id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-2">
                    {insumo.imagen ? (
                      <img
                        src={insumo.imagen}
                        alt={insumo.nombre}
                        className="w-16 h-16 object-cover rounded"
                      />
                    ) : (
                      <span className="text-gray-400 italic">Sin imagen</span>
                    )}
                  </td>
                  <td className="px-4 py-2">{insumo.nombre}</td>
                  <td className="px-4 py-2">{insumo.categoria}</td>
                  <td className="px-4 py-2 font-bold text-green-600">
                    S/. {insumo.precio}
                  </td>
                  <td className="px-4 py-2">{insumo.descripcion}</td>
                  <td className="px-4 py-2 text-center">
                    <Link
                      to={`/editar-insumo/${regionId}/${insumo.id}`}
                      className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded mr-2"
                    >
                      ✏️ Editar
                    </Link>
                    <button
                      className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
                      onClick={() =>
                        firebase.db.collection(`productos_${regionId}`).doc(insumo.id).delete()
                      }
                    >
                      🗑 Eliminar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500 italic">
                  No hay insumos registrados en {regionId}.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Catalogos;
